import { BaseEnum } from "services/enums/baseEnum";

const listsEnum: Array<FormStatusType> = [];

export class FormStatusType extends BaseEnum {
  static DRAFT = new FormStatusType(0, "DRAFT", "Rascunho", "secondary");
  static PUBLISHED = new FormStatusType(1, "PUBLISHED", "Publicado", "success");
  static UNPUBLISHED = new FormStatusType(
    2,
    "UNPUBLISHED",
    "Não Publicado",
    "danger"
  );

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public className: string
  ) {
    super(id, value, label, className);
    listsEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listsEnum;
  }
}
